/**
 * @param {{ms: number}} ms
 * @returns {Promise<void>}
 */
export const wait = ({ms = 300}) => new Promise((resolve) => setTimeout(resolve, ms));